import { useDispatch } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import { useConfirm } from 'material-ui-confirm';
import { noop } from 'lodash';
import { permanentlyDeleteAllDocumentsAction } from 'domain/documents';

import Box from '@mui/material/Box';

interface TrashCategoryActions {
  handlePermanentlyDeleteAll: () => void;
}

const useTrashCategoryActions = (): TrashCategoryActions => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const confirm = useConfirm();

  const dispatchPermanentlyDeleteAll = () => {
    dispatch(permanentlyDeleteAllDocumentsAction());
  };

  const handlePermanentlyDeleteAll = () => {
    const keyword = formatMessage({
      id: 'confirm.keyword.delete',
      defaultMessage: 'delete',
    }).toLowerCase();

    confirm({
      title: formatMessage({
        id: 'confirm.company.bar.permanentlyDeleteAll.title',
        defaultMessage: 'Delete all documents permanently?',
      }),
      content: (
        <>
          <FormattedMessage
            id="confirm.company.bar.permanentlyDeleteAll.description"
            defaultMessage='Are you sure you want to permanently delete all documents from the trash? If so, please type "{keyword}" in the box below'
            values={{
              keyword,
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
          <Box sx={{ pt: 1, color: 'error.main', fontWeight: 500 }}>
            {formatMessage({
              id: 'confirm.default.attention',
              defaultMessage: 'Attention! This action cannot be undone',
            })}
          </Box>
        </>
      ),
      confirmationKeyword: keyword,
      confirmationText: formatMessage({
        id: 'button.delete',
        defaultMessage: 'Delete',
      }),
      cancellationText: formatMessage({
        id: 'button.cancel',
        defaultMessage: 'Cancel',
      }),
      confirmationButtonProps: {
        color: 'error',
      },
    })
      .then(() => {
        dispatchPermanentlyDeleteAll();
      })
      .catch(noop);
  };

  return {
    handlePermanentlyDeleteAll,
  };
};

export default useTrashCategoryActions;
